var _objectSpread = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

// Handle request body
var addBody = function addBody(body, parameters, opts) {
  if (!body) {
    return opts;
  }

  var bodyA = typeof body === 'function' ? body() : body;

  if (isBinaryBody(parameters)) {
    return _objectSpread({}, opts, {
      body: bodyA,
      headers: _objectSpread({
        'Content-Type': 'application/octet-stream'
      }, opts.headers)
    });
  }

  return _objectSpread({}, opts, {
    body: JSON.stringify(bodyA),
    headers: _objectSpread({
      'Content-Type': 'application/json'
    }, opts.headers)
  });
};

var isBinaryBody = function isBinaryBody(parameters) {
  return Object.values(parameters.body).some(isBodyParam);
};

var isBodyParam = function isBodyParam(_ref) {
  var schema = _ref.schema;
  return schema && schema.format === 'binary';
};

module.exports = {
  addBody: addBody
};